import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from '../services/utils/util.service';

@Pipe({
    name: 'dateInSiteTimeZone'
})
export class DateInSiteTimeZonePipe implements PipeTransform {
    constructor(private utilServ: UtilsService) {}
    transform(
        value: string | number | Date,
        timezone: string,
        format?: string
    ): string | null {
        return this.utilServ.convertDateToOtherFormat(value, timezone, format);
    }
}
